import React from 'react';
import {useFetchVacancy} from '@rocket-ui/lk-api';
import {useParams} from 'react-router-dom';
import {Offer} from 'widgets/offer-details';
import styles from 'widgets/order-details/ui/OrderPage.module.css';

export function OfferPage(): React.ReactElement {
	const {offerId} = useParams<{offerId: string}>();
	const id = offerId != null && offerId !== '' ? Number(offerId) : NaN;
	const {
		data: vacancy,
		isLoading,
		isError,
		error,
	} = useFetchVacancy(
		{id},
		{
			enabled: Number.isFinite(id),
		},
	);

	if (!Number.isFinite(id)) return <p className={styles.errorText}>Некорректный id предложения.</p>;
	if (isLoading) return <p className={styles.stateText}>Загрузка предложения...</p>;
	if (isError) {
		return (
			<p className={styles.errorText}>{error instanceof Error ? error.message : 'Не удалось загрузить предложение'}</p>
		);
	}
	if (!vacancy) return <p className={styles.stateText}>Предложение не найдено.</p>;

	return <Offer vacancy={vacancy} />;
}
